import { Component, OnInit, OnDestroy, Output, EventEmitter } from '@angular/core';
import { Subscription } from 'rxjs';

import { UiService } from 'src/app/shared/services/ui.service';

@Component({
    selector: 'app-main-header',
    templateUrl: './main-header.component.html',
    styleUrls: ['./main-header.component.scss']
})
export class MainHeaderComponent implements OnInit, OnDestroy {
    @Output() sidenavToggle = new EventEmitter<void>();

    private pageTitleSub: Subscription;
    pageTitle: string;
    isAuth: boolean;

    constructor(
        private uiSrv: UiService
    ) { }

    ngOnInit() {
        this.initSubscriptions();
    }

    onToggleSidenav(): void {
        this.sidenavToggle.emit();
    }

    private initSubscriptions(): void {
        this.pageTitleSub = this.uiSrv.pageTitleChanged
        .subscribe(pageTitle => {
            this.pageTitle = pageTitle;
        });
    }

    ngOnDestroy(): void {
        if(this.pageTitleSub) {
            this.pageTitleSub.unsubscribe();
        }
    }
}
